  <template>
  <v-toolbar
    flat
    dense
    fixed
    app
    dark
    color="grey darken-4"
    :clipped-left="$vuetify.breakpoint.mdAndUp"
  >
    <v-toolbar-side-icon @click.stop="leftBar()"></v-toolbar-side-icon>

    <v-toolbar-title class="body-1">
      {{ getMenuActive }}
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <span style="padding-right: 10px" v-if="nomeSel.Nome">
      {{ nomeSel.Nome }}
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon small v-on:click="rimuoviSwitchUser">
          <v-icon>close</v-icon>
        </v-btn>
        <span>Rimuovi filtro</span>
      </v-tooltip>
    </span>

    <span>{{ utente }}</span>

    <v-menu
      offset-y
      :close-on-click="true"
      :close-on-content-click="false"
      :nudge-width="200"
    >
      <v-btn icon slot="activator">
        <v-icon>account_circle</v-icon>
      </v-btn>

      <v-card>
        <v-list>
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-icon :x-large="true">account_circle</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{ utente }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="grey darken-3" flat v-on:click="gotoAccount"
            >Account</v-btn
          >

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-3"
            flat
            v-on:click="esci"
            :disabled="disabilitaBtn"
            >Esci</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    utente: { type: String, default: "" },
    nomeSel: null,
  },

  data: () => ({
    disabilitaBtn: false,
  }),

  methods: {
    esci() {
      this.disabilitaBtn = true;

      this.$emit("esci");
    },

    leftBar() {
      let v = this.$store.getters["app/getLeftBar"];

      this.$store.commit("app/SET_LEFTBAR", !v);
    },

    gotoAccount() {
      this.$router.push({ path: "profiloUtente" });
    },

    rimuoviSwitchUser() {
      this.$store.commit("user/SET_USERSWITCH", {});
    },
  },

  computed: {
    getMenuActive: function () {
      return this.$store.getters["app/getMenuActive"] || "Home";
    },
  },
};
</script>

